import gql from 'graphql-tag';

export default gql`
  mutation projectGoLive($id: Int!, $userIds: [Int!]!) {
    projectGoLive(id: $id, userIds: $userIds)
  }
`;
